import React, { useContext, useState } from "react";
import {
  useTheme,
  Box,
  Typography,
  TextField,
  IconButton,
  List,
  ListItem,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { AppState } from "../../../common/types";
import RemoveCircleRoundedIcon from "@material-ui/icons/RemoveCircleRounded";
import { makeStyles } from "@material-ui/styles";
import { ISelectedDriverOrVehicle, GroupMembersContext } from "./context";
import classnames from "classnames";
import { useTranslate } from "react-admin";

interface GroupDriversInputProps {
  source: string;
  removeMember: (member: ISelectedDriverOrVehicle) => void;
  contextField: "selectedDrivers" | "selectedVehicles";
  title: string;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: any) => ({
  borderColorDark: { borderColor: theme.palette.grey[600] },
  borderColorLight: { borderColor: theme.palette.grey[400] },
}));

const shouldDisplay = (member: ISelectedDriverOrVehicle, filter: string) => {
  return (
    !filter || member.name.toUpperCase().indexOf(filter.toUpperCase()) > -1
  );
};

export const SelectedMembersDisplay = ({
  removeMember,
  contextField,
  title,
  source,
  disabled,
  ...rest
}: GroupDriversInputProps) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const themeName = useSelector((x: AppState) => x.theme);
  const context = useContext(GroupMembersContext);
  const [filter, setFilter] = useState<string>("");
  const translate = useTranslate();

  return (
    <Box
      className="simple-list-placeholder"
      style={{
        borderColor:
          themeName === "dark"
            ? theme.palette.grey[600]
            : theme.palette.grey[400],
      }}>
      <Typography className="simple-list-title" variant="body2">
        {title}
      </Typography>
      <TextField
        className="simple-list-search-box"
        size="small"
        variant="outlined"
        label={translate("resources.common.labels.search")}
        value={filter}
        onChange={(e) => {
          setFilter(e.target.value);
        }}
      />
      <List
        className={classnames(
          "simple-list",
          themeName === "dark"
            ? classes.borderColorDark
            : classes.borderColorLight
        )}>
        {context[contextField] &&
          context[contextField].map((member, idx) => {
            return (
              shouldDisplay(member, filter) && (
                <ListItem
                  key={idx}
                  className="simple-list-item"
                  style={{
                    borderColor:
                      themeName === "dark"
                        ? theme.palette.grey[600]
                        : theme.palette.grey[400],
                  }}>
                  <div className={`record-info source-${source}`}>
                    <Typography variant="body2">{member.name}</Typography>
                    <Typography variant="caption">{member.status}</Typography>
                  </div>
                  {!disabled ? (
                    <IconButton
                      style={{ color: theme.palette.error.main }}
                      onClick={() => {
                        removeMember(member);
                      }}>
                      <RemoveCircleRoundedIcon />
                    </IconButton>
                  ) : null}
                </ListItem>
              )
            );
          })}
      </List>
    </Box>
  );
};
